// Copyright (c) Meta Platforms, Inc. and affiliates.
// All rights reserved.

// This source code is licensed under the license found in the
// LICENSE file in the root directory of this source tree.

import React, { useState } from 'react'
import AppContext from './createContext'
import { modelInputProps } from '../Interfaces'
import { SEGTYPE_HOVER } from '../config'

const AppContextProvider = (props: {
  children: React.ReactElement<any, string | React.JSXElementConstructor<any>>
}) => {
  const [clicks, setClicks] = useState<Array<modelInputProps>>([])
  const [image, setImage] = useState<HTMLImageElement | null>(null)
  const [maskImg, setMaskImg] = useState<HTMLImageElement | null>(null)
  const [resultMask, setResultMask] = useState<HTMLImageElement | null>(null)
  const [resultHightlightMask, setResultHighlightMask] = useState<HTMLImageElement | null>(null)
  const [clipData, setClipData] = useState<any | null>(null)
  const [stickers, setStickers] = useState<any[]>([])
  const [segmentType, setSegmentType] = useState<string | null>(SEGTYPE_HOVER)
  const [currentImage, setCurrentImage] = useState<string | null>(null)
  const [currentImageData, setCurrentImageData] = useState<ImageData | null>(null)
  const [currentImageIndex, setCurrentImageIndex] = useState<number | null>(null)
  const [clickType, setClickType] = useState<number>(1)
  const [isReset, setIsReset] = useState<boolean>(false)
  const [canvasWidth, setCanvasWidth] = useState<number>(0)
  const [canvasHeight, setCanvasHeight] = useState<number>(0)
  const [everythingMask, setEverythingMask] = useState<any[]>([])
  const [isEverythingRemoved, setIsEverythingRemoved] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [isChanging, setIsChanging] = useState<boolean>(false)
  const [overCircle, setOverCircle] = useState<number | null>(null)
  const [isSaving, setIsSaving] = useState<boolean>(true)
  return (
    <AppContext.Provider
      value={{
        clicks: [clicks, setClicks],
        image: [image, setImage],
        maskImg: [maskImg, setMaskImg],
        resultMask: [resultMask, setResultMask],
        resultHighlightMask: [resultHightlightMask, setResultHighlightMask],
        clipData: [clipData, setClipData],
        stickers: [stickers, setStickers],
        segmentType: [segmentType, setSegmentType],
        currentImage: [currentImage, setCurrentImage],
        currentImageData: [currentImageData, setCurrentImageData],
        currentImageIndex: [currentImageIndex, setCurrentImageIndex],
        clickType: [clickType, setClickType],
        isReset: [isReset, setIsReset],
        canvasWidth: [canvasWidth, setCanvasWidth],
        canvasHeight: [canvasHeight, setCanvasHeight],
        everythingMask: [everythingMask, setEverythingMask],
        isEverythingRemoved: [isEverythingRemoved, setIsEverythingRemoved],
        isLoading: [isLoading, setIsLoading],
        isChanging: [isChanging, setIsChanging],
        overCircle: [overCircle, setOverCircle],
        isSaving: [isSaving, setIsSaving]
      }}
    >
      {props.children}
    </AppContext.Provider>
  )
}

export default AppContextProvider
